<template>
  <base-display-widget :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners">
    <div class="w-full h-full" ref="phone" style="min-height: 146px">
<!--      标题 通过链接设置&&显示标题-->
      <div class="w-full h-40 p-h-10 flex a-center" v-if="iteminfo.config.showMenuTitle && iteminfo.config.contentType===1">
        <div class="color-33 fs-14">{{iteminfo.config.menutitle}}</div>
        <div class="flex-1"></div>
        <div  class="color-33 fs-14">更多</div>
      </div>
      <div style="min-height: 80px" v-if="iteminfo.config.displayType === 3">
        <ul class="p-h-5">
          <li :key="index" class="p-5" v-for="(item,index) in getshowDataList">
            <ratio-div :RadioValue="63">
              <div class="w-full h-full absolute top-0 left-0">
                <div class="w-full h-full relative">
                  <img :src="getdefaultVideoImg(item)"
                       class="w-full h-full"
                       style="cursor: pointer"/>
                  <div class="flex a-center j-center"
                       style="position: absolute;top:0;left:0;width: 100%;height: 100%"
                       v-if="item.videoUrl">
                    <i class="icon-player fs-40 text-white"></i>
                  </div>
                </div>
              </div>
            </ratio-div>
            <div class="p-t-5 lin1" style="overflow: hidden" v-if="item.videoTitle">
              {{ item.videoTitle }}
            </div>
          </li>
        </ul>
      </div>
      <div class="bg-white"
           style="min-height: 72px"
           :style="{paddingLeft:getItemHPadding,paddingRight:getItemHPadding,paddingTop:getItemVPadding,paddingBottom:getItemVPadding}"
           v-if="iteminfo.config.displayType === 1">
        <ul class="flex j-start flex-wrap p-4">
          <li :key="index" class="p-4 flex-s-0"
              style="width: 50%"
              :style="{paddingLeft:getItemHPadding,paddingRight:getItemHPadding,paddingTop:getItemVPadding,paddingBottom:getItemVPadding}"
              v-for="(item,index) in getshowDataList">
            <ratio-div :RadioValue="75">
              <div class="w-full h-full absolute top-0 left-0">
                <div class="w-full h-full relative">
                  <img :src="getdefaultTwoVideoImg(item)"
                       class="w-full h-full"
                       style="cursor: pointer"/>
                  <div class="flex a-center j-center"
                       style="position: absolute;top:0;left:0;width: 100%;height: 100%"
                       v-if="item.videoUrl">
                    <i class="icon-player fs-30 text-white"></i>
                  </div>
                </div>
              </div>
            </ratio-div>
            <div class="p-5" v-if="item.videoTitle" style="overflow: hidden">
              {{ item.videoTitle }}
            </div>
          </li>
        </ul>
      </div>
      <div class="bg-white" style="min-height: 60px" v-if="iteminfo.config.displayType === 2">
        <ul class="p-h-5">
          <li :key="index" class="p-5" v-for="(item,index) in getshowDataList">
            <img :src="getdefaultListVideoImg(item)" alt="" class="w-full v-a-top"
                 v-if="!item.coverImgUrl && !item.videoUrl">
            <div class="flex a-center" v-if="item.coverImgUrl || item.videoUrl">
              <ratio-div :RadioValue="75" class="flex-s-0" style="width: 120px">
                <div class="w-full h-full absolute top-0 left-0 flex a-center j-center o-hidden">
                  <img :src="getdefaultListVideoImg(item)"
                       class="w-full h-full"
                       style="cursor: pointer;min-height: 100%"/>
                  <div class="flex a-center j-center"
                       style="position: absolute;top:0;left:0;width: 100%;height: 100%"
                       v-if="item.coverImgUrl || item.videoUrl">
                    <i class="icon-player fs-30 text-white"></i>
                  </div>
                </div>
              </ratio-div>
              <div class="flex-column m-l-10 p-10 flex-1"
                   style="align-items: flex-start;justify-content: space-between;height: 90px;background-color: #F9F9F9">
                <div class="lin1 bold" style="overflow: hidden">
                  {{ item.videoTitle }}
                </div>
                <!--              <div class="">-->
                <!--                <span class="bold" style="">12:3:00</span>-->
                <!--              </div>-->
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div :phoneHeight="phoneHeight"
           v-if="iteminfo.config.displayType === 4">
        <Carousel :autoplay="false" :dots="'inside'" :loop="false"
                  ref="carousel"
                  id="car"
                  :radiusDot="true"
                  v-model:value="carouselIndex"
        >
          <CarouselItem :key="index" v-for="(item,index) in getshowDataList"
          >
            <img class="w-full h-full" src="../../../assets/common/img_ohter_guide@2x.png"
                 :style="{height:phoneHeight + 'px'}"
                 v-if="!item.coverImgUrl && !item.videoUrl"/>
            <img :src="getdefaultListVideoImg(item)"
                 class="w-full h-full"
                 :style="{height:phoneHeight + 'px'}"
                 v-if="item.coverImgUrl || item.videoUrl"
                 style="cursor: pointer;object-fit: contain"
            />
          </CarouselItem>
        </Carousel>
      </div>
    </div>
  </base-display-widget>
</template>

<script>
import BaseDisplayWidget from '../base/BaseDisplayWidget'
import RatioDiv from '../../common/RatioDiv'
import src from '@/assets/tempmenu/img_video_single.png'
import {parseUrl} from '@/utils/UrlFormat'
import {mapActions} from 'vuex'

export default {
  name: 'VideoDisplayWidget',
  components: {RatioDiv, BaseDisplayWidget},
  props: {
    iteminfo: Object,
    phoneHeight: {
      type: Number,
      default: 0,
    }
  },
  watch: {
    'iteminfo.config.datalist.length': {
      handler (newValue) {
        //全屏轮播式,避免越界黑屏
        if (this.iteminfo.config.displayType !== 4)
          return
        if (this.carouselIndex > newValue - 1) {
          this.carouselIndex = newValue - 1
        } else if (this.carouselIndex < 0) {
          this.carouselIndex = 0
        }
      }
    },

    getLinkShowInfo: {
      handler (newValue) {
        if (newValue.contentType === 1) {     //通过链接设置
          if (newValue.linkUrl){
            this.resolveLink()
          }else{
            this.defaultDataList = []
          }
        }
      },
      immediate: true,
      deep: true,
    }
  },
  data () {
    return {
      defaultDataList: [],
      // 轮播的index
      carouselIndex: 0,
    }
  },
  computed: {
    getshowDataList () {
      let list = []
      list = this.getDefaultProductList()
      return list
    },
    getLinkShowInfo () {            //通过链接地址设置的时候需要
      return {
        contentType: this.iteminfo.config.contentType,
        linkUrl: this.iteminfo.config.jumpObj.linkUrl,
        hasLimit: this.iteminfo.config.haslimit,
        rowCount: this.iteminfo.config.rowCount
      }
    },
    getItemHPadding () {
      return (this.iteminfo.config.hSpacing / 2) + 'px'
    },
    getItemVPadding () {
      return (this.iteminfo.config.vSpacing / 2) + 'px'
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
    },
    getdefaultVideoImg (item) {
      let src = require('../../../assets/tempmenu/img_video_single.png')
      if (item.coverImgUrl) {
        src = item.coverImgUrl
      } else if (item.mp4Url && item.mp4Url.endsWith('.mp4')) {
        src = item.mp4Url + '?x-oss-process=video/snapshot,t_1000,f_png,w_0,h_0'
      } else if (item.videoUrl && item.videoUrl.endsWith('.mp4')) {
        src = item.videoUrl + '?x-oss-process=video/snapshot,t_1000,f_png,w_0,h_0'
      }
      return src
    },
    getdefaultTwoVideoImg (item) {
      let src = require('../../../assets/tempmenu/img_video_abreast.png')
      if (item.coverImgUrl) {
        src = item.coverImgUrl
      } else if (item.mp4Url && item.mp4Url.endsWith('.mp4')) {
        src = item.mp4Url + '?x-oss-process=video/snapshot,t_1000,f_png,w_0,h_0'
      } else if (item.videoUrl && item.videoUrl.endsWith('.mp4')) {
        src = item.videoUrl + '?x-oss-process=video/snapshot,t_1000,f_png,w_0,h_0'
      }
      return src
    },
    getdefaultListVideoImg (item) {
      let src = require('../../../assets/tempmenu/img_video_list.png')
      if (item.coverImgUrl) {
        src = item.coverImgUrl
      } else if (item.mp4Url && item.mp4Url.endsWith('.mp4')) {
        src = item.mp4Url + '?x-oss-process=video/snapshot,t_1000,f_png,w_0,h_0'
      } else if (item.videoUrl && item.videoUrl.endsWith('.mp4')) {
        src = item.videoUrl + '?x-oss-process=video/snapshot,t_1000,f_png,w_0,h_0'
      }
      return src
    },
    getDefaultProductList () {
      // let templist = []
      // let length = 1
      // if (this.iteminfo.config.displayType === 1) {
      //   length = 1
      // } else if (this.iteminfo.config.displayType === 2) {
      //   length = 2
      // } else if (this.iteminfo.config.displayType === 3) {
      //   length = 2
      // }
      // let len = this.iteminfo.config.datalist.length || 0
      // if (length <= len) {
      //   templist = this.iteminfo.config.datalist
      // } else {
      //   templist = templist.concat(this.iteminfo.config.datalist)
      //   for (let i = 0; i < (length - len); i++) {
      //     templist.push({
      //       id: 0,
      //       coverImgUrl: '',
      //       videourl: '',
      //       title: '',
      //       process: ''
      //     })
      //   }
      // }
      // return templist
      if (this.getLinkShowInfo.contentType) {  //链接请求
        return this.defaultDataList
      } else {      //自上传
        return this.iteminfo.config.datalist
      }
    },

    resolveLink () {              //解析链接,获取视频列表
      let url = this.iteminfo.config.jumpObj.linkUrl
      if (!url)
        return
      let par = parseUrl(url)
      if (par.contentType && (parseInt(par.contentType) === 51 || parseInt(par.contentType) === 52)) {      //多视频
        let params = {
          pageSize: this.calcPageSize(),
          pageNum: 1
        }
        let id = par.id
        switch (parseInt(par.contentType)) {
          case 51:
            params.categoryId = id
            break
          case 52:
            params.groupId = id
            break
        }

        this.getVideoList(params).then(res => {
          if (res.code === 0) {
            res.data.list.forEach(item => {
              item.videoUrl = item.sourceUrl || item.url
            })
            this.defaultDataList = res.data.list
          }
        })
      } else if (par.contentType && parseInt(par.contentType) === 53) {              //单独视频的link
        let id = par.id
        let params = {}
        this.getVideoDetail({
          id,
          params
        }).then(res => {
          if (res.code === 0) {
            if (res.data)
              this.defaultDataList = [
                {
                  ...res.data,
                  videoUrl: res.data.sourceUrl || res.data.url
                }
              ]
            else
              this.defaultDataList = []
          }
        })
      }
    },
    calcPageSize () {    //根据链接获取的数据需要pageSize
      let pageSize = 20  //最大20
      if (!this.iteminfo.config.haslimit)
        return pageSize

      let maxRowCount = this.iteminfo.config.rowCount
      if (this.iteminfo.config.displayType === 1) {     //两列
        pageSize = maxRowCount * 2
      } else if (this.iteminfo.config.displayType === 2) {
        pageSize = maxRowCount
      } else if (this.iteminfo.config.displayType === 3) {
        pageSize = maxRowCount
      }
      if (pageSize > 20) pageSize = 20
      return pageSize
    },
    ...mapActions([
      'getVideoList',
      'getVideoDetail'
    ])
  }
}
</script>

<style lang="scss" scoped>
.lin1 {
  color: #333;
  max-width: 600px;
  font-size: 13px;
  line-height: 20px;
  //height: 40px;
  //margin-top: 6px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 1; /** 显示的行数 **/
  overflow: hidden; /** 隐藏超出的内容 **/
}
</style>
